module.exports = __webpack_public_path__ + "static/img/org_title7.7d8ab97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/org_title7.png
// module id = rOmE
// module chunks = 4